
export const formStyle = {
  containerInput: {
    float: "left",
    marginRight: "2%"
  },

  clearFloatContainer: {
    clear: "both"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/style.js